var render = function render(){var _vm=this,_c=_vm._self._c;return _c(`h${_vm.data.level}`,{tag:"component",class:['editorHeader', `editorHeader--h${_vm.data.level}`],attrs:{"id":_vm.slugify(_vm.data.text, {
      lower: true,
      strict: true,
    })}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }